import React, { useEffect, useState } from "react";
import { FieldArray, Formik } from "formik";
import * as yup from "yup";
import { DialogActions, InputAdornment } from "@material-ui/core";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import {
  FormArrayTextField,
  FormOutlinedTextField,
} from "../../../../../partials/content/Forms/FormField";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledNoMarginTextField,
} from "../../../../../partials/content/Forms";
import Illustration from "../../../../../partials/content/Illustration";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import { Card, Badge } from "react-bootstrap";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import {
  getJourneyStocksUnload,
  saveJourneyStocksUnload,
} from "../../../../../services/crm/salesJourney";
import { Table } from "react-bootstrap";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
function StockUnloadForm({ stock, onConfirmSave, onCloseUnloadForm }) {
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [stockUnload, setStockUnload] = useState({
    stockLoadedQty: stock.qty,
    data: [],
  });
  useEffect(() => {
    getJourneyStocksUnloadData(stock.ID);
  }, [stock.ID]);

  const stockUnloadSchema = yup.object().shape({
    data: yup
      .array()
      .of(
        yup.object().shape({
          itemStockID: yup.number(),
          warehouseID: yup.number(),
          warehouseName: yup.string().required("Warehouse is required"),
          itemID: yup.number(),
          varCode: yup.string(),
          qtyUnload: yup
            .number()
            .transform((value) => (isNaN(value) ? 0 : value))
            .nullable()
            .required("Quantity is required")
            .min(1, "Quantity cannot be zero or empty")
            .max(
              stock.qty,
              "Returned Quantity cannot be more than Stock Loaded Quantity"
            )
            .default(0),
        })
      )
      .required("Please select stock to unload"),
  });

  return (
    <Formik
      initialValues={stockUnload}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={stockUnloadSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        let totalStockUnload = 0;
        values.data.forEach((stockData) => {
          if (stockData.ID === 0 && !stockData.deleteInd) {
            totalStockUnload += stockData.qtyUnload;
            stockData.qtyUnload = parseFloat(stockData.qtyUnload);
          }
        });
        if (totalStockUnload > values.stockLoadedQty) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Failed",
            text: "Returned Quantity is more than Loaded Quantity",
            icon: "error",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        } else {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to return this Journey Stock ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, return it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveJourneyStocksUnload(values.data).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Returned",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }
      }}
    >
      {({
        dirty,
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <FieldArray name="data">
            {({ push, remove }) => (
              <React.Fragment>
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-window-maximize"></i>
                        <span>
                          <strong>Stock Return Header</strong>
                        </span>
                        <Badge
                          className="float-right ml-1"
                          variant={
                            stock.statusID === 1
                              ? "info"
                              : stock.statusID === 3
                              ? "success"
                              : stock.statusID === 4
                              ? "warning"
                              : stock.statusID === 5
                              ? "primary"
                              : stock.statusID === 9
                              ? "danger"
                              : stock.statusID === 10
                              ? "danger"
                              : null
                          }
                        >
                          {stock.statusID === 1
                            ? "Stock Requested"
                            : stock.statusID === 3
                            ? "Stock Loaded"
                            : stock.statusID === 4
                            ? "Stock Partially Returned"
                            : stock.statusID === 5
                            ? "Stock Returned"
                            : stock.statusID === 9
                            ? "Stock Cancelled"
                            : stock.statusID === 10
                            ? "Stock Rejected"
                            : null}
                        </Badge>
                      </Card.Header>
                      <Card.Body>
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Request ID"
                              value={stock.itemRequestID}
                            />
                            <FormOutlinedTextField
                              label="Item Code"
                              value={stock.itemCode}
                              InputProps={{
                                startAdornment:
                                  stock.itemType > 0 ? (
                                    <InputAdornment position="start">
                                      <BootstrapTooltip
                                        title={stock.itemTypeName}
                                      >
                                        <i
                                          className={
                                            stock.itemType === 1
                                              ? "fas fa-boxes text-success"
                                              : stock.itemType === 2
                                              ? "fas fa-tools text-primary"
                                              : stock.itemType === 3
                                              ? "fas fa-building text-info"
                                              : stock.itemType === 4
                                              ? "fas fa-boxes text-warning"
                                              : stock.itemType === 5
                                              ? "fas fa-boxes text-danger"
                                              : null
                                          }
                                        ></i>
                                      </BootstrapTooltip>
                                    </InputAdornment>
                                  ) : null,
                                readOnly: true,
                              }}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Item Name"
                              value={stock.itemName}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Batch ID"
                              value={stock.batchID}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Stock Loaded Quantity"
                              value={values.stockLoadedQty}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Unit"
                              value={stock.uomName}
                            />
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="card">
                      <Table borderless size="sm" responsive="xl">
                        {values.data && values.data.length > 0 ? (
                          <thead className="text-center">
                            <tr>
                              <th style={{ width: "40%" }}>
                                Destination Warehouse
                              </th>
                              <th style={{ width: "25%" }}>
                                Returned Quantity
                              </th>
                              <th style={{ width: "30%" }}>Unit</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                        ) : null}
                        <tbody>
                          {values.data && values.data.length > 0 ? (
                            values.data.map((stockItem, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {stockItem.statusID === 1 ? (
                                      <FormArrayTextField
                                        index={index}
                                        arrayPropName="data"
                                        propName="warehouseName"
                                        margin="none"
                                        searchButton
                                        readonly
                                        onSearchClick={() => {
                                          setItemIndex(index);
                                          setOpenSearchWarehouse(true);
                                        }}
                                      />
                                    ) : (
                                      <CustomOutlinedDisabledNoMarginTextField
                                        value={stockItem.warehouseName}
                                      />
                                    )}
                                  </td>
                                  <td>
                                    {stockItem.statusID === 1 ? (
                                      <FormArrayTextField
                                        index={index}
                                        arrayPropName="data"
                                        propName="qtyUnload"
                                        quantityField
                                        margin="none"
                                      />
                                    ) : (
                                      <CustomOutlinedDisabledNoMarginTextField
                                        value={stockItem.qtyUnload}
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <CustomOutlinedDisabledNoMarginTextField
                                      value={stockItem.itemUom.uomName}
                                    />
                                  </td>
                                  <td
                                    style={{ whiteSpace: "nowrap" }}
                                    className="text-center"
                                  >
                                    {stockItem.statusID === 1 ? (
                                      <BootstrapTooltip
                                        title={
                                          stockItem.deleteInd
                                            ? "Undo Delete"
                                            : "Delete Stock Return Item"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className={`btn btn-icon btn-label-${
                                            stockItem.deleteInd
                                              ? "warning"
                                              : "danger"
                                          } btn-md btn-circle mx-1`}
                                          onClick={() => {
                                            if (stockItem.ID > 0) {
                                              setFieldValue(
                                                `data[${index}].deleteInd`,
                                                !stockItem.deleteInd
                                              );
                                            } else {
                                              remove(index);
                                            }
                                          }}
                                        >
                                          {stockItem.deleteInd ? (
                                            <i className="fas fa-undo-alt"></i>
                                          ) : (
                                            <i className="fas fa-trash-alt"></i>
                                          )}
                                        </button>
                                      </BootstrapTooltip>
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center py-3" colSpan="4">
                                <Illustration
                                  imageSource="INVIFO Inventory.png"
                                  guidance="You don't have any Returned items yet"
                                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                  size="sm"
                                ></Illustration>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="text-center py-3" colSpan="4">
                              <button
                                type="button"
                                className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                onClick={() => {
                                  const stockData = { ...stock };
                                  stockData.ID = 0;
                                  stockData.warehouseID = stock.warehouseID;
                                  stockData.warehouseName =
                                    stock.warehouse.warehouseName;
                                  stockData.statusID = 1;
                                  stockData.deleteInd = false;
                                  push(stockData);
                                }}
                              >
                                <i className="fas fa-plus-circle"></i>
                                Add Stock Return Item
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
          </FieldArray>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseUnloadForm}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>

          <DialogLayout
            open={openSearchWarehouse}
            title="Search Warehouse"
            onCloseDialog={handleCloseSearchWarehouse}
            maxWIdth="md"
          >
            <SearchWarehouse
              onSelectWarehouse={(warehouse) => {
                setFieldValue(`data[${itemIndex}].warehouseID`, warehouse.ID);
                setFieldValue(
                  `data[${itemIndex}].warehouseName`,
                  warehouse.warehouseName
                );
                handleCloseSearchWarehouse();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchWarehouse}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  async function getJourneyStocksUnloadData(journeyStockID) {
    const response = await getJourneyStocksUnload(journeyStockID);
    const { data } = response.data;
    setStockUnload({
      stockLoadedQty: stock.qty,
      data: data.journeyStocksUnload,
    });
  }

  function handleCloseSearchWarehouse() {
    setOpenSearchWarehouse(false);
  }
}

export default StockUnloadForm;
